import React from 'react'
import { Table, Button, Popup, Confirm, Label, Modal, Form, Input } from 'semantic-ui-react'
import fixModalStyle from '../utils/fixModalStyle'

const inlineStyle = {
    modal : {
      marginTop: '0px !important',
      marginLeft: 'auto',
      marginRight: 'auto',
    }
  };

class SubAnswersList extends React.Component {
    state = { answerToDelete: null, 
                subAnswers: {}, newAnswer: '', subAnswersButton:{}, newAnswerButton:false }

    handleDeleteClick = (answer) => this.setState({ answerToDelete: answer })
    handleCancelDelete = () => this.setState({ answerToDelete: null })
    handleConfirmDelete = () => {
        this.props.onDelete(this.state.answerToDelete)
        this.setState({ answerToDelete: null })
    }

    handleEditSubAnswer = (event, {answerId}) => {
        if (answerId === 'newanswer'){
            this.setState({newAnswer: event.target.value, newAnswerButton:true}); 
        }else{
            this.setState({subAnswers: {...this.state.subAnswers, [answerId]:event.target.value},
                subAnswersButton: {...this.state.subAnswersButton, [answerId]:true}
            });
        }
    }

    resetState(){
        this.setState({
            subAnswers :{},
            newAnswer: '',
            subAnswersButton :{},
            newAnswerButton: {},
        })
    }


    onSaveClick = (answerId, mainAnswer) => {
        const text = (answerId === 'newanswer')?this.state.newAnswer:this.state.subAnswers[answerId];
        if (text !=='') {
            const answerToSave = {
                id: answerId,
                question_id:mainAnswer.question_id,
                is_blackanswer:mainAnswer.is_blackanswer,
                quote:mainAnswer.quote,
                text: text,
                refer_to: mainAnswer.id
            }
            this.props.onSaveAnswer(answerToSave)
        }
        this.resetState();
        }

    renderConfirmDelete() {
        const {answerToDelete } = this.state
        if (!answerToDelete)
            return

        return <Confirm open style={fixModalStyle}
            //content={'Sicuro di voler cancellare ' + answerToDelete.text + '?'} 
            content={<Modal.Content>Sicuro di voler cancellare <b>{answerToDelete.text}</b>?</Modal.Content>} 
            onCancel={this.handleCancelDelete}
            onConfirm={this.handleConfirmDelete} />
    }


    render(){
        const { subAnswers, onDeleteClick, mainAnswer } = this.props
        return ( 
        <Table>
                {this.renderConfirmDelete()}
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Risposta</Table.HeaderCell>
                        <Table.HeaderCell>Quota</Table.HeaderCell>
                        <Table.HeaderCell width={1} />
                    </Table.Row>
                </Table.Header>
                <Table.Row style={{background: '#B413EC '}}>
                            <Table.Cell>{mainAnswer.text}</Table.Cell>
                            <Table.Cell>{mainAnswer.quote || <Label>Black Answer</Label>}</Table.Cell>
                            <Table.Cell singleLine>MAIN ANSWER</Table.Cell>
                </Table.Row>
                <Table.Body>
                    {subAnswers && subAnswers.length ? 
                        subAnswers.map(answer => (
                            <Table.Row style={{background: '#c161e2'}}>
                            <Table.Cell> 
                            <Form.Field control={Input} focus = {true} answerId={answer.id} id='subForm' onChange= {this.handleEditSubAnswer} fluid placeholder= {answer.text}/>  
                            </Table.Cell>
                            <Table.Cell>{answer.quote || <Label>Black Answer</Label>}</Table.Cell>
                            <Table.Cell singleLine>
                            <Popup trigger={<Button icon='save' disabled = {!this.state.subAnswersButton[answer.id]} onClick={() => this.onSaveClick(answer.id, mainAnswer)} />} content='Salva' />
                            <Popup trigger={<Button icon='trash' onClick={(e) => {onDeleteClick(answer); e.stopPropagation() }} />} content='Elimina' />
                            </Table.Cell>
                            </Table.Row>
                        ) ):
                        <Table.Row><Table.Cell><i>Nessuna risposta</i></Table.Cell></Table.Row>}
                        <Table.Row style={{background: '#cb9bdb'}}> 
                            <Table.Cell>
                                <Form.Field control={Input} id = 'newForm' answerId = {'newanswer'} onChange= {this.handleEditSubAnswer} fluid placeholder= {'Inserisci qui una nuova risposta'}/>  
                             </Table.Cell>
                            <Table.Cell>{mainAnswer.quote || <Label>Black Answer</Label>}</Table.Cell>
                            <Table.Cell singleLine>
                            <Popup trigger={<Button icon='save' disabled = {!this.state.newAnswerButton} onClick={() => this.onSaveClick('newanswer', mainAnswer)} />} content='Salva' />
                            </Table.Cell>
                         </Table.Row>
                </Table.Body>
            </Table>
       )
    }

}



class Answer extends React.Component {

    render(){
        const { answer, active, onEditClick, onDelete, onSaveAnswer, onDeleteClick, subAnswers } = this.props;

        return (
            <Table.Row active={active}>
            <Table.Cell>{answer.text}</Table.Cell>
            <Table.Cell>{answer.quote || <Label>Black Answer</Label>}</Table.Cell>
            <Table.Cell singleLine>
                <Label>{subAnswers?subAnswers.length:0} sottorispost{subAnswers && subAnswers.length===1?'a':'e'}</Label>
                <Modal trigger={<Button icon='plus square' />} content='Vedi sotto risposte' style={inlineStyle.modal}>
                    <Modal.Header>Aggiungi le sottorisposte</Modal.Header>
                    <Modal.Content>
                            <SubAnswersList mainAnswer={answer} subAnswers={subAnswers}
                                            onEditClick={onEditClick} onDeleteClick={onDeleteClick}
                                            onDelete ={onDelete} onSaveAnswer = {onSaveAnswer}/>
                    </Modal.Content>
                </Modal>
                <Popup trigger={<Button icon='edit' onClick={() => onEditClick(answer)} />} content='Modifica' />
                <Popup trigger={<Button icon='trash' onClick={(e) => {onDeleteClick(answer); e.stopPropagation() }} />} content='Elimina' />
            </Table.Cell>
            </Table.Row>
        )
    }

}

export default class AnswersList extends React.Component {
    state = { answerToDelete: null }

    handleDeleteClick = (answer) => this.setState({ answerToDelete: answer })
    handleCancelDelete = () => this.setState({ answerToDelete: null })
    handleConfirmDelete = () => {
        this.props.onDelete(this.state.answerToDelete)
        this.setState({ answerToDelete: null })
    }

    handleEditClick = (answer) => {
        this.props.onEdit(answer)
    }

    answerSort = (ans1,ans2) => {
        if (ans1.quote === ans2.quote){
                return (ans1.id.localeCompare(ans2.id))
        }
        else return (ans1.quote - ans2.quote)
    }

    renderConfirmDelete() {
        const {answerToDelete } = this.state
        if (!answerToDelete)
            return

        return <Confirm open style={fixModalStyle}
            //content={'Sicuro di voler cancellare ' + answerToDelete.text + '?'} 
            content={<Modal.Content>Sicuro di voler cancellare <b>{answerToDelete.text}</b>?</Modal.Content>} 
            onCancel={this.handleCancelDelete}
            onConfirm={this.handleConfirmDelete} />
    }

    render() {
        const { answers, selectedAnswer } = this.props
        var mainAnswers = [];
        var subAnswers = [];
        for (var i = 0; i < answers.length; i++){
            if (answers[i].refer_to === answers[i].id){
                mainAnswers.push(answers[i]);
            } else{
                if (!(subAnswers[answers[i].refer_to])){
                    subAnswers[answers[i].refer_to] = [];
                }
                subAnswers[answers[i].refer_to].push(answers[i])
            }
        }   
        mainAnswers.sort(this.answerSort);
        const keys = Object.keys(subAnswers);
        for (i = 0; i < keys.length; i++){
            subAnswers[keys[i]].sort(this.answerSort);

        }
       return (
            <Table>
                {this.renderConfirmDelete()}
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Risposta</Table.HeaderCell>
                        <Table.HeaderCell>Quota</Table.HeaderCell>
                        <Table.HeaderCell width={1} />
                    </Table.Row>
                </Table.Header>
        
                <Table.Body>
                    {mainAnswers.length ? 
                        mainAnswers.map(answer => 
                                <Answer  active={answer === selectedAnswer} key={answer.id} 
                                        answer={answer}  subAnswers={subAnswers[answer.id]} 
                                        onEditClick={this.handleEditClick} onDelete ={this.props.onDelete} 
                                        onDeleteClick={this.handleDeleteClick} onSaveAnswer ={this.props.onSaveAnswer}/>) :
                        <Table.Row><Table.Cell><i>Nessuna risposta</i></Table.Cell></Table.Row>}
                </Table.Body>
            </Table>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AnswersList.js